import React from 'react';

const EmptyContent = ({ title }) => (
  <div className="flex text-xs md:text-sm text-gray-500 w-full justify-center my-2 md:my-4">{title}</div>
);

export default EmptyContent;
